import React, { ReactElement, useState } from 'react';
import styled from 'styled-components';
import './styles.scss';
import { Heading2 } from '../Theme/Theme';
import { ClientDetail } from '../../types/adminPortalApiSchema';
import { StyledBlueButton } from '../Button/Button';
import { ConfirmationDialog } from '../Dialogs/Confirmation/Confirmation';
import { ContinueDialog } from '../Dialogs/Continue/Continue';
import { resetClientData } from './resetClientData';

type Props = {
  user: ClientDetail;
};

export const ClientResetDataSection = ({
  user,
}: Props): ReactElement | null => {
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const [showContinueDialog, setShowContinueDialog] = useState(false);
  return (
    <ClientResetWrapper>
      <div>
        <Heading2>Reset account</Heading2>
        <p>
          Delete any previous plan data and allow the user to start again with a
          fresh plan.
        </p>
      </div>
      <StyledClientResetButton
        data-testid={'reset-client-button'}
        onClick={(): void => {
          setShowConfirmationDialog(true);
        }}
        kind="secondary"
        size="default"
        tabIndex={0}
        type="button"
      >
        Reset client data
      </StyledClientResetButton>
      {showConfirmationDialog && (
        <ConfirmationDialog
          headline={`Are you sure you want to reset ${user.name}?`}
          byline="After resetting the account, the account will need to go through tailoring again, so the account can not be restored."
          dismissButtonText="Cancel"
          confirmButtonText="Reset account"
          confirmButtonColor="red"
          confirmButtonCallback={async (): Promise<void> => {
            return resetClientData(user.id)
              .then((res) => {
                console.log(res);
                const success = res?.data?.resetClientData;
                if (success === true) {
                  setShowConfirmationDialog(false);
                  setShowContinueDialog(true);
                } else {
                  throw new Error('Received a response, but was not success.');
                }
              })
              .catch((err) => {
                console.log({ err });
                setShowConfirmationDialog(false);
                alert(
                  `Resetting this account failed, please contact an administrator to help resolve this, quoting User ID: ${user.id}.`
                );
              });
          }}
          dismissButtonCallback={(): void => {
            setShowConfirmationDialog(false);
          }}
          warning={true}
        ></ConfirmationDialog>
      )}
      {showContinueDialog && (
        <ContinueDialog
          headline={`${user.name}'s account has been reset`}
          continueButtonText="Continue"
          continueButtonCallback={(): void => {
            setShowContinueDialog(false);
          }}
        ></ContinueDialog>
      )}
    </ClientResetWrapper>
  );
};

const ClientResetWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 50px;
  border: 1px solid ${(props): string => props.theme.grey};
  margin-top: 70px;
`;

export const StyledClientResetButton = styled((props) => (
  <StyledBlueButton {...props} />
))`
  width: 178px;
  height: 48px;
`;
